import { Input } from 'antd';
import React from 'react';
import { useGroupGeofencePageContext } from '../../GroupGeofencePage.context';
var SearchGeofence = function () {
    var context = useGroupGeofencePageContext();
    return (React.createElement(Input.Search, { placeholder: "Search", enterButton: false, onChange: function (e) { return context.setSearchGeofence(e.target.value); } }));
};
export default SearchGeofence;
